document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("[data-el-announcement-timer]");
  if (!sections.length) return;

  const pad = (value) => String(value).padStart(2, "0");

  const getTargetDate = (section) => {
    const targetDate = section.dataset.targetDate || "";
    const targetTime = section.dataset.targetTime || "00:00:00";

    if (!targetDate) return null;

    const normalizedTime =
      targetTime.length === 5 ? `${targetTime}:00` : targetTime;
    const localDate = new Date(`${targetDate}T${normalizedTime}`);

    return Number.isNaN(localDate.getTime()) ? null : localDate;
  };

  sections.forEach((section) => {
    const hoursEl = section.querySelector("[data-el-hours]");
    const minutesEl = section.querySelector("[data-el-minutes]");
    const secondsEl = section.querySelector("[data-el-seconds]");
    let target = getTargetDate(section);

    if (!hoursEl || !minutesEl || !secondsEl || !target) return;

    const updateCountdown = () => {
      const now = new Date();

      while (target.getTime() <= now.getTime()) {
        target.setDate(target.getDate() + 1);
      }

      const diff = target.getTime() - now.getTime();
      const totalSeconds = Math.floor(diff / 1000);

      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    };

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
